// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

export const PUBLIC_URL = parseString(process?.env?.PUBLIC_URL) ?? 'http://localhost:3000';

function parseString (value : any) : string | undefined {
    if (!value) return undefined;
    return value;
}
